import { call } from "redux-saga/effects"
import { getToken } from "./token"
import { downloadAttachment, processResponse } from "./utils"
import { set } from "lodash"

export function* get(url, noToken, abortSignal) {
  const request = {
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }

  // Add abort signal if provided and valid
  if (abortSignal && abortSignal instanceof AbortSignal) {
    request.signal = abortSignal
  }

  if (!noToken) {
    const token = yield call(getToken)
    request.headers["X-OmegaPoint-Code"] = token
  }

  const result = yield call(fetch, url, request)
  return yield call(processResponse, result)
}

export function* put(url, payload, noToken, abortSignal) {
  const request = {
    credentials: "same-origin",
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }

  // Add abort signal if provided and valid
  if (abortSignal && abortSignal instanceof AbortSignal) {
    request.signal = abortSignal
  }
  if (!noToken) {
    const token = yield call(getToken)
    request.headers["X-OmegaPoint-Code"] = token
  }

  const result = yield call(fetch, url, request)
  return yield call(processResponse, result)
}

export function* patch(url, payload, abortSignal) {
  const token = yield call(getToken)

  const request = {
    credentials: "same-origin",
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-OmegaPoint-Code": token,
    },
    body: JSON.stringify(payload),
  }

  // Add abort signal if provided and valid
  if (abortSignal && abortSignal instanceof AbortSignal) {
    request.signal = abortSignal
  }

  const result = yield call(fetch, url, request)
  return yield call(processResponse, result)
}

export function* post(url, payload, noToken, abortSignal) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  }

  if (!noToken) {
    const token = yield call(getToken)
    set(headers, "X-OmegaPoint-Code", token)
  }

  return yield call(postRaw, url, JSON.stringify(payload), { headers, abortSignal })
}

export function* postRaw(url, payload, { headers, abortSignal }) {
  const request = {
    credentials: "same-origin",
    method: "POST",
    headers,
    body: payload,
  }

  // Add abort signal if provided and valid
  if (abortSignal && abortSignal instanceof AbortSignal) {
    request.signal = abortSignal
  }

  const result = yield call(fetch, url, request)
  return yield call(processResponse, result)
}

export function* del(url, payload, abortSignal) {
  const token = yield call(getToken)
  const request = {
    credentials: "same-origin",
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-OmegaPoint-Code": token,
    },
    body: JSON.stringify(payload),
  }

  // Add abort signal if provided and valid
  if (abortSignal && abortSignal instanceof AbortSignal) {
    request.signal = abortSignal
  }

  const result = yield call(fetch, url, request)
  return yield call(processResponse, result)
}

export function* downloadFile(url) {
  const token = yield call(getToken)

  const response = yield call(fetch, url, {
    credentials: "same-origin",
    headers: {
      Accept: "application/zip, application/octet-stream, */*",
      "X-OmegaPoint-Code": token,
    },
  })

  yield call(downloadAttachment, response)
}
